import { RootState } from "store/index";
import { UserRead } from "client/jspPlatformExperiment";

const userAccount = (state: RootState): UserRead | null =>
  state.userAccount.userAccount;

const userAccountIsLoading = (state: RootState): boolean =>
  state.userAccount.isLoading;

const userAccountError = (state: RootState): string | null =>
  state.userAccount.error;

const userFullName = (state: RootState): string | null =>
  state.userAccount.userAccount?.full_name ?? null;

const userId = (state: RootState): number | null =>
  state.userAccount.userAccount?.id ?? null;

const userEthnicity = (state: RootState): string | null =>
  state.userAccount.userAccount?.ethnicity ?? null;

const userDateOfBirth = (state: RootState): string | null =>
  state.userAccount.userAccount?.date_of_birth ?? null;

const userGender = (state: RootState): string | null =>
  state.userAccount.userAccount?.gender ?? null;

const userWeight = (state: RootState): number | null =>
  state.userAccount.userAccount?.weight ?? null;

const userGroups = (state: RootState) =>
  state.userAccount.userAccount?.user_groups ?? null;

const userUpdatedAt = (state: RootState): string | null =>
  state.userAccount.userAccount?.updated_at ?? null;

export default {
  userAccount,
  userAccountIsLoading,
  userAccountError,
  userFullName,
  userId,
  userEthnicity,
  userDateOfBirth,
  userGender,
  userWeight,
  userGroups,
  userUpdatedAt,
};
